import { ReturnReasonSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/return-reasons";
import { ProductDataSchema } from "@redotech/redo-model/customer-portal/product";
import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

// Birdy Grey's external exchange recommendations — an ordered product list.
export const getBirdyGreyExchangeRecommendations = unaryRpc({
  name: "getBirdyGreyExchangeRecommendations" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    returnReasons: z.array(ReturnReasonSchema),
    locale: z.string().optional(),
  }),
  output: z.object({
    recommendedProducts: z.array(
      z.object({
        product: ProductDataSchema,
        recommendedOptions: z.array(
          z.object({ optionName: z.string(), optionValue: z.string() }),
        ),
      }),
    ),
  }),
});
